import React, { Component } from "react";
import { injectIntl } from "react-intl";
import MessageBox from "../MessageBox";
import ChatDescription from "../ChatDescription";
import { Menu, Icon, Dropdown } from "antd";
import "./MessageBoxWrapper.scss";
import { ReactComponent as CloseSvg } from "../../assets/icon/ic_close_24dp.svg";

function MenuChatSwapper({
  hiddenChats,
  openMessageBox,
  closeChat,
  getChatTitle,
  notifications,
  flags,
}) {
  return (
    hiddenChats.length && (
      <Menu className="menu-chat-swap">
        {hiddenChats.map((chat, index) => {
          return (
            <Menu.Item
              key={index}
              className={`${notifications[chat.id] ? "unread" : ""}`}
            >
              <div
                className="menu-swap-item"
                onClick={() => openMessageBox(chat)}
              >
                <div className="message-props">
                  <span
                    className={`message-title ${
                      notifications[chat.id] ? "unread" : ""
                    }`}
                  >
                    {getChatTitle(chat)}
                  </span>
                </div>
                <Icon
                  className="action-button"
                  onClick={(e) => {
                    e.stopPropagation();
                    closeChat(chat.id);
                  }}
                  component={CloseSvg}
                />
              </div>
            </Menu.Item>
          );
        })}
      </Menu>
    )
  );
}

function MessagesDropdown({
  hiddenChats,
  openMessageBox,
  closeChat,
  getChatTitle,
  notifications,
  hiddenHasUnreadMessages,
  flags,
}) {
  return (
    !!hiddenChats.length && (
      <Dropdown
        placement="topRight"
        overlay={
          <MenuChatSwapper
            hiddenChats={hiddenChats}
            openMessageBox={openMessageBox}
            closeChat={closeChat}
            getChatTitle={getChatTitle}
            notifications={notifications}
            flags={flags}
          />
        }
      >
        <div
          className={`hidden-conversations-container ${
            hiddenHasUnreadMessages ? "notify" : ""
          }`}
        >
          <span className="hidden-chats-button">+{hiddenChats.length}</span>
        </div>
      </Dropdown>
    )
  );
}

function MessageBoxes(props) {
  const {
    flags,
    chats,
    closeChat,
    setChatAsRead,
    onCardClick,
    getChatNewMessages,
    dismissNotification,
    handshakeNewChatCreated,
    connection,
    updateChatName,
    getChatList,
    notifications,
    profiles,
    mentions,
  } = props;

  return chats.map((chat) => (
    <MessageBox
      id={chat.id}
      chat={chat}
      key={chat.id}
      onCardClick={onCardClick}
      closeChat={closeChat}
      wsConnection={connection}
      newMessage={getChatNewMessages(chat.id)}
      notifications={notifications}
      dismissNotification={dismissNotification}
      handshakeNewChatCreated={handshakeNewChatCreated}
      setChatAsRead={setChatAsRead}
      updateChatName={updateChatName}
      getChatList={getChatList}
      flags={flags}
      profiles={profiles}
      mentions={mentions}
    />
  ));
}

class MessageBoxWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  getChatTitle(item) {
    const { flags } = this.props;
    const { formatMessage } = this.props.intl;
    const currentFlag = flags.find(
      (elem) => elem.id === (item.flags && item.flags[0] && item.flags[0].id)
    );
    const archivedPrefix =
      (currentFlag && currentFlag.alternativeArchivedPrefix) ||
      "chat.archivedPrefix";

    if (item.newChat) {
      return formatMessage({ id: "chat.newChat" });
    } else if (item.description) {
      return item.archived
        ? `${formatMessage({ id: archivedPrefix })} ${item.description}`
        : item.description;
    }
    return formatMessage(
      { id: "chat.noDescriptionTitle" },
      {
        name: item.createdBy.username,
        archived: item.archived ? formatMessage({ id: archivedPrefix }) : "",
        number: item.recipients.length - 1,
      }
    );
  }

  hiddenHasUnreadMessages() {
    for (let i in this.props.hiddenChats) {
      let hidden = this.props.hiddenChats[i];
      if (this.props.notifications[hidden.id]) return true;
    }
    return false;
  }

  render() {
    const {
      hiddenChats,
      openMessageBox,
      closeChat,
      notifications,
      flags,
      chats,
      onCardClick,
      getChatNewMessages,
      dismissNotification,
      handshakeNewChatCreated,
      setChatAsRead,
      wsConnection,
      updateChatName,
      getChatList,
      profiles,
      mentions,
    } = this.props;

    return (
      <div className="message-boxes-wrapper">
        <MessagesDropdown
          hiddenChats={hiddenChats}
          openMessageBox={openMessageBox}
          closeChat={closeChat}
          getChatTitle={this.getChatTitle.bind(this)}
          notifications={notifications}
          hiddenHasUnreadMessages={this.hiddenHasUnreadMessages()}
          flags={flags}
        />
        <MessageBoxes
          chats={chats}
          closeChat={closeChat}
          onCardClick={onCardClick}
          getChatNewMessages={getChatNewMessages}
          notifications={notifications}
          dismissNotification={dismissNotification}
          handshakeNewChatCreated={handshakeNewChatCreated}
          setChatAsRead={setChatAsRead}
          connection={wsConnection}
          updateChatName={updateChatName}
          getChatList={getChatList}
          flags={flags}
          profiles={profiles}
          mentions={mentions}
        />
      </div>
    );
  }
}

export default injectIntl(MessageBoxWrapper);
